import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";

import vertText from "_src/shaders/surfels_normalization/surfels_normalization.glslv";
import fragText from "_src/shaders/surfels_normalization/surfels_normalization.glslf";

export default class SurfelsNormalizationShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms();
    this.depthTest = false;

  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms() {
    this.uniforms["u_text_diffuse"] = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
  }

}
